import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { closingWith, closingWithout } from '../data/landingContent';
import { Button } from './Button';
import { Container } from './Container';
import { Highlight, SectionHeading } from './SectionHeading';
export function ClosingSection() {
  return <section className="bg-cream py-14 sm:py-20 lg:py-28" data-id="element-19" data-mp="xthd93j39pa6">
      <Container data-id="element-20" data-mp="xw3l749w66sx">
        <SectionHeading eyebrow="The choice is simple" title={<>
              Two ways to start <Highlight data-id="element-22" data-mp="17sq2jj30efq7">your next lesson</Highlight>
            </>} data-id="element-21" data-mp="1cqroqcvqev5w" />
        <div className="mx-auto grid max-w-[960px] grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2" data-id="element-23" data-mp="1ljuvk2bvg9rk">
          <div className="rounded-2xl border border-line bg-white p-5 sm:p-8" data-id="element-24" data-mp="1hh81rvvn4erq">
            <h3 className="font-condensed text-[26px] font-bold uppercase text-muted" data-id="element-25" data-mp="1vhitf14rxxdy">Planning from scratch</h3>
            <ul className="mt-5 space-y-3.5" data-id="element-26" data-mp="1qiodc6y6ymxj">
              {closingWithout.map(item => <li key={item} className="flex gap-3 text-[15px] text-muted" data-id="element-27" data-mp="22clywh9tbg9v">
                  <XIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-muted/60" data-id="element-28" data-mp="22eoz1u4oipsb" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-navy p-5 text-white sm:p-8" data-id="element-29" data-mp="2ccmnahmjgmkx">
            <h3 className="font-condensed text-[26px] font-bold uppercase text-teal-light" data-id="element-30" data-mp="2gcwsvt6f5az9">With Lessons Ready™</h3>
            <ul className="mt-5 space-y-3.5" data-id="element-31" data-mp="2laos789e7zdh">
              {closingWith.map(item => <li key={item} className="flex gap-3 text-[15px]" data-id="element-32" data-mp="2q8qcfwik24qj">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-teal-light" strokeWidth={3} data-id="element-33" data-mp="2v0rkt7clrbba" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-[620px] text-center sm:mt-14" data-id="element-34" data-mp="3430slpghkqkz">
          <p className="font-condensed text-[27px] font-extrabold uppercase leading-tight text-navy sm:text-[36px]" data-id="element-35" data-mp="39012kbggidhd">
            Open the lesson. See the steps. <Highlight data-id="element-36" data-mp="18wgoso02t37b">Start teaching.</Highlight>
          </p>
          <p className="mt-3 text-sm text-muted" data-id="element-37" data-mp="14xzho4gnnspw">1 book · 36 lessons · 5 bonuses · $27 USD · 10-day guarantee</p>
          <Button href="#offer-details" className="mt-8 w-full sm:w-auto" data-id="element-38" data-mp="1ipxhtpse2e9x">
            Get Instant Access
          </Button>
        </div>
      </Container>
    </section>;
}